// Predefined measurement templates for interior / contracting trades.
// Each template defines fields the user must capture and the natural unit.

export const MEASUREMENT_TEMPLATES = {
  Door: {
    icon: "🚪",
    unit: "Sq.ft",
    fields: [
      { key: "door_type", label: "Door Type", type: "select", options: ["Flush", "Panel", "Sliding", "French", "Pocket", "Glass"] },
      { key: "height", label: "Height (ft)", type: "number", required: true },
      { key: "width", label: "Width (ft)", type: "number", required: true },
      { key: "thickness", label: "Thickness (mm)", type: "number" },
      { key: "frame_material", label: "Frame Material", type: "select", options: ["Wood", "WPC", "Steel", "Aluminium"] },
      { key: "shutter_material", label: "Shutter Material", type: "select", options: ["Teak", "Sal", "Veneer", "Laminate", "Membrane", "PVC"] },
      { key: "finish", label: "Finish", type: "text" },
      { key: "hardware", label: "Hardware / Fittings", type: "text" },
    ],
  },
  Wardrobe: {
    icon: "🪟",
    unit: "Sq.ft",
    fields: [
      { key: "style", label: "Style", type: "select", options: ["Sliding", "Openable", "Walk-in"] },
      { key: "height", label: "Height (ft)", type: "number", required: true },
      { key: "width", label: "Width (ft)", type: "number", required: true },
      { key: "depth", label: "Depth (ft)", type: "number" },
      { key: "partitions", label: "No. of Partitions", type: "number" },
      { key: "shutters", label: "No. of Shutters", type: "number" },
      { key: "drawers", label: "No. of Drawers", type: "number" },
      { key: "carcass_material", label: "Carcass", type: "select", options: ["BWP Ply", "BWR Ply", "MDF", "Particle Board"] },
      { key: "shutter_finish", label: "Shutter Finish", type: "select", options: ["Laminate", "Acrylic", "Veneer", "Membrane", "Paint"] },
      { key: "loft", label: "With Loft?", type: "select", options: ["Yes", "No"] },
    ],
  },
  Kitchen: {
    icon: "🍳",
    unit: "R.ft",
    fields: [
      { key: "layout", label: "Layout", type: "select", options: ["Straight", "L-Shape", "U-Shape", "Parallel", "Island"] },
      { key: "base_length", label: "Base Cabinet Length (ft)", type: "number", required: true },
      { key: "wall_length", label: "Wall Cabinet Length (ft)", type: "number" },
      { key: "tall_unit_length", label: "Tall Unit Length (ft)", type: "number" },
      { key: "countertop", label: "Countertop", type: "select", options: ["Granite", "Quartz", "Marble", "Corian", "Stainless Steel"] },
      { key: "carcass_material", label: "Carcass", type: "select", options: ["BWP Ply", "BWR Ply", "Marine Ply", "MDF"] },
      { key: "shutter_finish", label: "Shutter Finish", type: "select", options: ["Laminate", "Acrylic", "Membrane", "Veneer", "PU"] },
      { key: "appliances", label: "Built-in Appliances", type: "text" },
    ],
  },
  Window: {
    icon: "🖼️",
    unit: "Sq.ft",
    fields: [
      { key: "window_type", label: "Type", type: "select", options: ["Sliding", "Casement", "Fixed", "French", "Bay"] },
      { key: "height", label: "Height (ft)", type: "number", required: true },
      { key: "width", label: "Width (ft)", type: "number", required: true },
      { key: "frame", label: "Frame Material", type: "select", options: ["UPVC", "Aluminium", "Wood", "Steel"] },
      { key: "glass", label: "Glass Type", type: "select", options: ["Clear", "Frosted", "Tinted", "Toughened", "Double-glazed"] },
      { key: "mesh", label: "Mosquito Mesh?", type: "select", options: ["Yes", "No"] },
      { key: "grill", label: "Grill / Safety Bars?", type: "select", options: ["Yes", "No"] },
    ],
  },
  "False Ceiling": {
    icon: "📐",
    unit: "Sq.ft",
    fields: [
      { key: "ceiling_type", label: "Ceiling Type", type: "select", options: ["Gypsum", "POP", "PVC", "Wooden", "Grid"] },
      { key: "length", label: "Length (ft)", type: "number", required: true },
      { key: "width", label: "Width (ft)", type: "number", required: true },
      { key: "design", label: "Design / Pattern", type: "text" },
      { key: "lighting", label: "Lighting Plan", type: "text" },
      { key: "cove_light", label: "Cove / Profile Light?", type: "select", options: ["Yes", "No"] },
    ],
  },
  Flooring: {
    icon: "🧱",
    unit: "Sq.ft",
    fields: [
      { key: "flooring_type", label: "Flooring Type", type: "select", options: ["Tile", "Marble", "Granite", "Wooden", "Vinyl", "Laminate", "Epoxy"] },
      { key: "length", label: "Length (ft)", type: "number", required: true },
      { key: "width", label: "Width (ft)", type: "number", required: true },
      { key: "thickness", label: "Tile / Plank Size", type: "text" },
      { key: "skirting", label: "Skirting Required?", type: "select", options: ["Yes", "No"] },
    ],
  },
  Custom: {
    icon: "✏️",
    unit: "Sq.ft",
    fields: [
      { key: "description", label: "Description", type: "text" },
      { key: "height", label: "Height", type: "number" },
      { key: "width", label: "Width", type: "number" },
      { key: "depth", label: "Depth", type: "number" },
      { key: "specs", label: "Specifications", type: "text" },
    ],
  },
};
